export enum ColumnTypes {
    OID = 'OID',
    dueDate = 'dueDate',
    expectedResponseDate = 'expectedResponseDate',
    potentialValue = 'potentialValue',
    proposedGrossMarginPercentage = 'proposedGrossMarginPercentage',
    probabilityValue = 'probabilityValue',
    opportunityStatusName = 'opportunityStatusName',
    salesUsers = 'salesUsers',
    companyNames = 'companyNames',
    companyRoleNames = 'companyRoleNames',
    divisionName = 'divisionName',
    isActive = 'isActive',
    salesperson = 'salesperson'
}
